import { Typography, Container, Button, InputBase } from "@mui/material";
import { RouteEnum } from "constants/RouteConstants";
import { NavLink, useSearchParams } from "react-router-dom";
import { ReactComponent as InstagramSvg } from "assets/svgs/instagram.svg";
import { ReactComponent as LinkedInSvg } from "assets/svgs/linkedin.svg";
import { ReactComponent as FaceBookSvg } from "assets/svgs/facebook.svg";
import GoLogoSvg from "common/GoLogoSvg";
import { AvailableForDownload } from "./AvailableForDownload";
import { AppDomainEnum } from "constants/Global";

function PublicFooter(props) {
  const [searchParams] = useSearchParams();

  const view = searchParams.get("view");

  if (view === "mobile-app") {
    return null;
  }

  return (
    <div className="pt-12 bg-[#231F1F] text-white">
      <Container>
        <div className="flex flex-wrap mb-8">
          <div className="w-full lg:w-1/5 mb-8">
            <GoLogoSvg variant={1} className="w-28 h-16" />
          </div>
          <div className="w-full md:w-2/4 lg:w-2/5">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 lg:gap-8 mb-4">
              {GROUP_LINKS.map((group, key) => (
                <div key={key}>
                  <Typography variant="h6" className="mb-6 font-semibold">
                    {group.name}
                  </Typography>
                  {group.links.map((link, key) => (
                    <div key={key} className="mb-4">
                      <Typography
                        variant="body1"
                        component={
                          link.href ? "a" : link?.to ? NavLink : undefined
                        }
                        target={link.target}
                        color="inherit"
                        {...link}
                        className="whitespace-nowrap"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="w-full md:w-2/4 lg:w-2/5">
            <div className="max-w-xs mx-auto">
              <Typography variant="h6" className="font-bold mb-2">
                Join our Newsletter
              </Typography>
              {/* <iframe
                title='substack'
                src='https://gocaby.substack.com/embed'
                width={islg ? '350' : '300'}
                height='250'
                style={{ border: '1px solid #EEE', background: 'white' }}
                frameborder='0'
                scrolling='no'
              ></iframe> */}
              <div className="w-full p-2 border rounded-full border-white hover:border-yellow-500 ">
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  color="white"
                  className="text-white w-full"
                  placeholder="Type your email address"
                  inputProps={{ "aria-label": "newsletter" }}
                />
              </div>
              <Button
                fullWidth
                size="large"
                borderradius="circular"
                className="mt-2"
                color="secondary"
                // href='https://gocaby.substack.com/embed'
                // target='_blank'
              >
                Join
              </Button>
            </div>
          </div>
        </div>
        {/* <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xs mx-auto sm:max-w-xl mb-4'>
          <Button
            variant='contained'
            size='large'
            borderradius='circular'
            href={AppDomainEnum.RIDE.concat(RouteEnum.SIGNUP)}
            color='secondary'
            className='py-3'
          >
            Signup to drive/deliver
          </Button>
          <AvailableForDownload className='bg-inherit border border-inherit' />
        </div> */}

        <div className="flex justify-center">
          <AvailableForDownload className="bg-inherit border border-inherit" />
        </div>

        <div className="flex items-center justify-end py-4 border-b">
          <div className="flex items-center gap-x-1 text-mui-secondary-main pr-2">
            {[
              {
                SvgIcon: FaceBookSvg,
                to: "https://www.facebook.com/gocabyofficial",
              },
              {
                SvgIcon: LinkedInSvg,
                to: "https://www.linkedin.com/company/gocabyofficial/",
              },
              {
                SvgIcon: InstagramSvg,
                to: "https://www.instagram.com/gocabyofficial?igshid=NTc4MTlwNjQ2YQ==",
              },
            ].map(({ SvgIcon, to }) => (
              <a key={to} href={to} target="_blank" rel="noreferrer">
                <SvgIcon fill="currentColor" />
              </a>
            ))}
          </div>
          {/* <Typography>@GOAPP</Typography> */}
        </div>
        <div className="py-4">
          <Typography variant="body2" className="text-center">
            All right reserve | GoCaby Technology Limited @ Copyright 2024
          </Typography>
        </div>
      </Container>
    </div>
  );
}

export default PublicFooter;

const GROUP_LINKS = [
  {
    name: "Product",
    links: [
      { children: "Go Ride", href: AppDomainEnum.RIDE },
      { children: "Go Delivery", href: AppDomainEnum.LOGISTICS },
      { children: "Go Eats", href: AppDomainEnum.SHOP },
    ],
  },
  {
    name: "Company",
    links: [
      {
        children: "How Go Works",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.ABOUT_HOW_GO_WORKS),
      },
      {
        children: "Learn",
        href: AppDomainEnum.DEFAULT.concat(
          RouteEnum.LEARN,
          "?viewMode=desktop"
        ),
      },
      {
        children: "About Us",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.ABOUT_US),
      },
      {
        children: "Career",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.CAREER),
      },
      {
        children: "Contact Us",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.CONTACT),
      },
      {
        children: "Blog",
        href: "https://gocaby.substack.com/",
        target: "_blank",
      },
      {
        children: "Terms & Condition",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.TERMS_CONDITIONS),
      },
      {
        children: "Privacy & Policy",
        href: AppDomainEnum.DEFAULT.concat(RouteEnum.PRIVACY_POLICY),
      },
    ],
  },
  {
    name: "Cities",
    links: [{ children: "Abuja" }, { children: "Lagos" }],
  },
];
